import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import app from './app'
import permission from './permission'
import org from './org'
import getters from './getters'
import account from './account'
import usercenter from './usercenter'
import district from './district'
import monitor from './monitor'
import scence from './scence'
import homepage from './homepage'
import applicationScenarios from './applicationScenarios'
import warningcenter from './warningcenter'
import meiyu from './meiyu'
import base from './base'
import riskchart from './riskchart'
import riverwatersituation from './riverwatersituation'
import comprehensiveMap from './comprehensiveMap'
import typhoonMap from './typhoonMap'
import reportAnalysis from './reportAnalysis' // 新增报表分析

Vue.use(Vuex)

const state = {
  allIconTables: [],
  allowPerm: {},
  tdataTotalNum: 0,
  sid: 22
}
const actions = {
  setSubMenu ({ commit }, name) {
    new Vue().ListSubMenu(name).then(data => {
      commit('subMenu', data)
    })
  },
  setAllowPerm ({ commit }, params) {
    if (params.name !== undefined && params.name !== '' && params.type !== undefined && params.type !== '') {
      var allows = new Vue().CheckOperateFunctions(params.name, params.type)
      commit('allowPerm', allows)
    }
  },
  setTdataTotalNum ({ commit }, data) {
    commit('tdataTotalNum', data)
  }
}

const mutations = {
  newAllIconTalbe (state, data) {
    state.allIconTables = data
  },
  subMenu (state, menu) {
    state.allIconTables = menu
  },
  allowPerm (state, allows) {
    state.allowPerm = allows
  },
  tdataTotalNum (state, data) {
    state.tdataTotalNum = data
  }
}
export default new Vuex.Store({
  modules: {
    app,
    user,
    usercenter,
    permission,
    org,
    account,
    district,
    monitor,
    scence,
    homepage,
    applicationScenarios,
    warningcenter,
    meiyu,
    base,
    riskchart,
    riverwatersituation,
    comprehensiveMap,
    typhoonMap,
    reportAnalysis
  },
  state,
  getters,
  actions,
  mutations: mutations
})
